import React from "react";
import { MetricCard } from "./ResultsPrimitives.jsx";
import { buildConsolidationCaptureDetails } from "../utils/consolidationCaptures.js";

const CARD = { className: "gap-0! rounded-[4px]! bg-slate-50/80! px-2! py-1! shadow-none!",
  labelClassName: "text-[0.52rem]! tracking-[0.07em]", valueClassName: "text-[0.76rem]! leading-tight! [overflow-wrap:anywhere]" };
const TAG = "inline-flex items-center rounded-[4px] px-1.5 py-0.5 text-[0.62rem] font-bold";
// Modification au brouillon : même orange que « Modifications non sauvegardées » de la Consolidation.
const TAG_TONE = { "Modification au brouillon": "bg-[#c2410c] text-white" };

// Geste de la page Consolidation : chauffeur, camions, période et résultat, puis le détail propre au geste.
export default function ConsolidationCaptureDetails({ feedback }) {
  const details = buildConsolidationCaptureDetails(feedback);
  if (!details) return null;
  return <div className="grid min-w-0 gap-1" data-consolidation-capture="true">
    {details.tags.length ? <div className="flex flex-wrap gap-1">{details.tags.map(tag => <span key={tag} data-consolidation-tag={tag}
      className={`${TAG} ${TAG_TONE[tag] || "border border-slate-400 bg-white text-slate-700"}`}>{tag}</span>)}</div> : null}
    <div className="grid min-w-0 grid-cols-2 gap-1 md:grid-cols-4">
      {details.rows.map(row => <MetricCard {...CARD} key={row.key} label={row.label} data-consolidation-detail={row.key} className={`${CARD.className} ${row.detail ? "col-span-2 md:col-span-1" : ""}`}
        value={row.detail ? <span className="grid gap-0.5">{row.value}<span className="text-[0.62rem] font-medium text-slate-600">{row.detail}</span></span> : row.value} />)}
      {details.lists.map(list => <MetricCard {...CARD} key={list.key} label={list.label} data-consolidation-detail={list.key} className={`${CARD.className} col-span-2 md:col-span-4`}
        value={<span className="grid gap-0.5 font-semibold">{list.items.map((item, index) => <span key={index}>{item}</span>)}</span>} />)}
    </div>
  </div>;
}
